require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/266f67551cd930edba7d6bd78b0aa629/code.js', () => { 

var regExp;



BackendlessUI.Functions.Custom['fn_266f67551cd930edba7d6bd78b0aa629'] = async function fn_266f67551cd930edba7d6bd78b0aa629(data) {
    regExp = (new RegExp('^(\\s*)?(\\+)?([- _():=+]?\\d[- _():=+]?){9,14}(\\s*)?$', 'g'));
  if ((regExp.test((data['phoneNumber']))) == false) {
    return ({ 'status': false });
  }


  return ({ 'status': true })
}

})
define('./functions/e42353f9b65e76e83a017a8bb41787a9/code.js', () => { 

var regExp;



BackendlessUI.Functions.Custom['fn_e42353f9b65e76e83a017a8bb41787a9'] = async function fn_e42353f9b65e76e83a017a8bb41787a9(data) {
    regExp = (new RegExp('[a-zA-Z0-9.\\-_+]{1,}@[^\\W\\.][a-zA-Z0-9.\\-]{2,}[.]{1}[a-zA-Z]{2,}', 'g'));
  if ((regExp.test((data['email']))) == false) {
    return ({ 'status': false });
  }


  return ({ 'status': true })
}

})
define('./pages/404/components/2705e15dacac71bd9b380c8cac042f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).indexOf('fa-bars') + 1;
  if ((((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == 'hidden' || (((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'] = 'visible';
  } else {
    delete ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'];
  }
  if (list == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-bars');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-times');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var contacts, serviceDataTable;


  serviceDataTable = (await Backendless.Data.of('Service').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  ___arguments.context.pageData['serviceData'] = serviceDataTable;
  contacts = (await Backendless.Data.of('ContactInfo').findFirst());
  ___arguments.context.pageData['phone'] = (contacts['phone']);
  ___arguments.context.pageData['address'] = (contacts['address']);
  ___arguments.context.pageData['email'] = (contacts['email']);
  ___arguments.context.pageData['map'] = (contacts['map']);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c437ff5d692611fcb95c24051539948f', (contacts['sociallinks']));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd89a514615b8f9515bc4bf2bd52aef8', (contacts['sociallinks']));

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/404/components/e984e4aa2e37874d708856168dd82283/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e984e4aa2e37874d708856168dd82283'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['phoneText']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/404/components/0e49a4ea4b9f3091e2fa7f712ff3d13c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/2a05c005a5a9bb6b89354307a948eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/404/components/5ddf06798a8cdbedae294e0d8065ab15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-facebook fab-light'] = 'fab fa-facebook fab-light';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-twitter fab-light'] = 'fab fa-twitter fab-light';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-instagram fab-light'] = 'fab fa-instagram fab-light';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/404/components/b5a874a995e7c43b2865e74b84e766ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/71681102fa9e5aad1bf2670bb9af564e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['footerPhone'] = (String('+1 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['footerPhone'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/404/components/bef8769418d88f1cc059638e42c2e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel: ') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef8769418d88f1cc059638e42c2e3ea'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['phoneText'] = (['If You Have Any Questions, ','Feel Free to Call ',(___arguments.context.pageData['phone'])].join(''));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/404/components/3e3600f6b5065862c8d66da40684cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/f307ad752263f65472397b5ff2c84322/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f307ad752263f65472397b5ff2c84322'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/404/components/4c96e02b0b5eed9fd1929ae59944387d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c96e02b0b5eed9fd1929ae59944387d'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/404/components/a50cedbcdbe4e187c28a26fd308e1187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a50cedbcdbe4e187c28a26fd308e1187'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/404/components/d7841cf4089f3765eceb3036d9de80a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/2911e9a9915d87eb86ee00d193573b75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/c54445ffc01c2768d6dfa53c44bb5db6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/2705e15dacac71bd9b380c8cac042f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).indexOf('fa-bars') + 1;
  if ((((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == 'hidden' || (((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'] = 'visible';
  } else {
    delete ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'];
  }
  if (list == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-bars');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-times');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var contacts, aboutMeDataTable, serviceDataTable, featuredInTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  featuredInTable = (await Backendless.Data.of('FeaturedIn').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f1553b4bb5a0612c71604c53bdbeed5')) && featuredInTable) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f1553b4bb5a0612c71604c53bdbeed5', featuredInTable);
  }
  ___arguments.context.pageData['topicsData'] = (await Backendless.Data.of('Topic').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(8)));
  serviceDataTable = (await Backendless.Data.of('Service').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  ___arguments.context.pageData['serviceData'] = serviceDataTable;
  aboutMeDataTable = (await Backendless.Data.of('AboutMe').findFirst());
  ___arguments.context.pageData['intro'] = (getObjectProperty(aboutMeDataTable, 'intro'));
  ___arguments.context.pageData['longbio'] = (getObjectProperty(aboutMeDataTable, 'longbio'));
  ___arguments.context.pageData['quote'] = (getObjectProperty(aboutMeDataTable, 'quote'));
  ___arguments.context.pageData['picture2'] = ((getObjectProperty(aboutMeDataTable, 'pictures'))[1]);
  ___arguments.context.pageData['picture3'] = ((getObjectProperty(aboutMeDataTable, 'pictures'))[2]);
  ___arguments.context.pageData['picture4'] = ((getObjectProperty(aboutMeDataTable, 'pictures'))[3]);
  ___arguments.context.pageData['video'] = (getObjectProperty(aboutMeDataTable, 'video'));
  ___arguments.context.pageData['testimonialsData'] = (await Backendless.Data.of('Testimonial').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  contacts = (await Backendless.Data.of('ContactInfo').findFirst());
  ___arguments.context.pageData['phone'] = (getObjectProperty(contacts, 'phone'));
  ___arguments.context.pageData['address'] = (getObjectProperty(contacts, 'address'));
  ___arguments.context.pageData['email'] = (getObjectProperty(contacts, 'email'));
  ___arguments.context.pageData['map'] = (getObjectProperty(contacts, 'map'));
  if (contacts && (getObjectProperty(contacts, 'sociallinks')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd89a514615b8f9515bc4bf2bd52aef8')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c437ff5d692611fcb95c24051539948f'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c437ff5d692611fcb95c24051539948f', (getObjectProperty(contacts, 'sociallinks')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd89a514615b8f9515bc4bf2bd52aef8', (getObjectProperty(contacts, 'sociallinks')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/about/components/53ab341bac3b970b637f029bc3045591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var logoLink;


  logoLink = (___arguments.context.getComponentDataStoreByUid('99a4a288b34992b378cfc82cce7bc7bd')['link']);
  if (logoLink) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(logoLink, true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('99a4a288b34992b378cfc82cce7bc7bd')['link']) != null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('99a4a288b34992b378cfc82cce7bc7bd'))['cursor'] = 'pointer';
  }

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/about/components/f2544014468f0fed9b8da2fb81ebb194/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f2544014468f0fed9b8da2fb81ebb194'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['intro']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/e984e4aa2e37874d708856168dd82283/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e984e4aa2e37874d708856168dd82283'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['phoneText']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/0e49a4ea4b9f3091e2fa7f712ff3d13c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/2a05c005a5a9bb6b89354307a948eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/5ddf06798a8cdbedae294e0d8065ab15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/a50cedbcdbe4e187c28a26fd308e1187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a50cedbcdbe4e187c28a26fd308e1187'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/about/components/bb053ec6b472de5bc53c446d275848fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var list;


  (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bb053ec6b472de5bc53c446d275848fe'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['quote']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/bef8769418d88f1cc059638e42c2e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phoneContacts'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef8769418d88f1cc059638e42c2e3ea'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['phoneText'] = (['If You Have Any Questions, ','Feel Free to Call ',(___arguments.context.pageData['phone'])].join(''));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/about/components/3e3600f6b5065862c8d66da40684cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/b5a874a995e7c43b2865e74b84e766ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/71681102fa9e5aad1bf2670bb9af564e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), true, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['footerPhone'] = (String('+1 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['footerPhone'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/18f2ffbc54033412354c341522842954/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/f307ad752263f65472397b5ff2c84322/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f307ad752263f65472397b5ff2c84322'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/about/components/4c96e02b0b5eed9fd1929ae59944387d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c96e02b0b5eed9fd1929ae59944387d'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/about/components/2911e9a9915d87eb86ee00d193573b75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/c54445ffc01c2768d6dfa53c44bb5db6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/0d24a333a28ae1f28739fb11cb31fc97/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceAssignment */
  onSourceAssignment(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'video')) {
    try {
      return (getObjectProperty(___arguments.context.pageData, 'video'));

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onSourceAssignment */
  /* content */
}))

define('./pages/contact/components/2705e15dacac71bd9b380c8cac042f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).indexOf('fa-bars') + 1;
  if ((((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == 'hidden' || (((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'] = 'visible';
  } else {
    delete ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'];
  }
  if (list == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-bars');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-times');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var component, contacts, serviceDataTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  serviceDataTable = (await Backendless.Data.of('Service').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  ___arguments.context.pageData['serviceData'] = serviceDataTable;
  contacts = (await Backendless.Data.of('ContactInfo').findFirst());
  ___arguments.context.pageData['phone'] = (getObjectProperty(contacts, 'phone'));
  ___arguments.context.pageData['address'] = (getObjectProperty(contacts, 'address'));
  ___arguments.context.pageData['email'] = (getObjectProperty(contacts, 'email'));
  ___arguments.context.pageData['map'] = (getObjectProperty(contacts, 'map'));
  if (contacts && (getObjectProperty(contacts, 'sociallinks')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd89a514615b8f9515bc4bf2bd52aef8')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c437ff5d692611fcb95c24051539948f')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b7af00b25ec2ab2f917e69b237f7c57'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd89a514615b8f9515bc4bf2bd52aef8', (getObjectProperty(contacts, 'sociallinks')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c437ff5d692611fcb95c24051539948f', (getObjectProperty(contacts, 'sociallinks')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3b7af00b25ec2ab2f917e69b237f7c57', (getObjectProperty(contacts, 'sociallinks')));
  }
  ___arguments.context.pageData['mapLocation'] = (getObjectProperty(contacts, 'mapPin'));
  if ((getObjectProperty(___arguments.context.pageData, 'scroll_to')) == 'form') {
    component = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('be0bf98b2e4f1343e6f89d02d43a61a8'));
    (function (component) { component.el.scrollIntoView() })(component);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/contact/components/e984e4aa2e37874d708856168dd82283/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e984e4aa2e37874d708856168dd82283'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['phoneText']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contact/components/0e49a4ea4b9f3091e2fa7f712ff3d13c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/2a05c005a5a9bb6b89354307a948eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contact/components/5ddf06798a8cdbedae294e0d8065ab15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contact/components/a50cedbcdbe4e187c28a26fd308e1187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a50cedbcdbe4e187c28a26fd308e1187'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/contact/components/bef8769418d88f1cc059638e42c2e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef8769418d88f1cc059638e42c2e3ea'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['phoneText'] = (['If You Have Any Questions, ','Feel Free to Call ',(___arguments.context.pageData['phone'])].join(''));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/contact/components/3e3600f6b5065862c8d66da40684cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/b5a874a995e7c43b2865e74b84e766ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/71681102fa9e5aad1bf2670bb9af564e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), true, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['footerPhone'] = (String('+1 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['footerPhone'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/contact/components/bb253e9fb54e0ee965ef1e7c44c39644/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'mapLocation')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb253e9fb54e0ee965ef1e7c44c39644'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'mapLocation')) == null ? [] : [(getObjectProperty(___arguments.context.pageData, 'mapLocation'))]);
  }

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'mapLocation')) {
    return (getObjectProperty(___arguments.context.pageData, 'mapLocation'));
  } else {
    return ({  });
  }

  },
  /* handler:onMapCenterAssignment */
  /* content */
}))

define('./pages/contact/components/c2b1a3e19ab3e6a413a912b9aa33b7ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'linkedIn') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('c2b1a3e19ab3e6a413a912b9aa33b7ae'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('c2b1a3e19ab3e6a413a912b9aa33b7ae'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('c2b1a3e19ab3e6a413a912b9aa33b7ae'))['fab fa-instagram'] = 'fab fa-instagram';
  } else if ((___arguments.context.getComponentDataStoreByUid('9c59f344b55264f9c758ff233715f8e5')['name']) == 'linkedIn') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('c2b1a3e19ab3e6a413a912b9aa33b7ae'))['fab fa-linkedin'] = 'fab fa-linkedin';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contact/components/f307ad752263f65472397b5ff2c84322/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f307ad752263f65472397b5ff2c84322'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/contact/components/4c96e02b0b5eed9fd1929ae59944387d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c96e02b0b5eed9fd1929ae59944387d'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/contact/components/8f53627aa0b8a35f198fdc34352cda63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var message, subject, phone, email, lastName, firstName, statusComment, statusSubject, statusPhoneValidation, statusEmailValidation, statusPhone, statusEmail, statusLastName, statusFirstName, alertMessage, wrongPhone, regExpPhone, wrongEmail, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  firstName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'firstName'));
  lastName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'lastName'));
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'email'));
  phone = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'phoneNumber'));
  subject = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'subject'));
  message = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'message'));
  alertMessage = 'This field is required.';
  regExp = (await BackendlessUI.Functions.Custom['fn_e42353f9b65e76e83a017a8bb41787a9'](___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')));
  regExpPhone = (await BackendlessUI.Functions.Custom['fn_266f67551cd930edba7d6bd78b0aa629'](___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')));
  wrongEmail = 'Please enter a valid email address.';
  wrongPhone = 'Please enter a valid phone number.';
  ___arguments.context.pageData['alertMessage'] = alertMessage;
  if (!firstName) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageFirstName'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9')), 'alert-border');
    }
    statusFirstName = false;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9')));
  }
  if (!lastName) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageLastName'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e3672305f3feaf45da95945d48d7dfda')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e3672305f3feaf45da95945d48d7dfda')), 'alert-border');
    }
    statusLastName = false;
  }
  if ((getObjectProperty(regExp, 'status')) == false) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageEmail'] = wrongEmail;
    statusEmailValidation = false;
  }
  if ((getObjectProperty(regExpPhone, 'status')) == false) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessagePhone'] = wrongPhone;
    statusPhoneValidation = false;
  }
  if (!email) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageEmail'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('742626d8325168e5c869103fe75a7d7e')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('742626d8325168e5c869103fe75a7d7e')), 'alert-border');
    }
    statusEmail = false;
  }
  if (!phone) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessagePhone'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')), 'alert-border');
    }
    statusPhone = false;
  }
  if (!subject) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageSubject'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('85b4da7593f19d25ac788697ba7686ea')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('85b4da7593f19d25ac788697ba7686ea')), 'alert-border');
    }
    statusSubject = false;
  }
  if (!message) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageComment'] = alertMessage;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('519f7e1b7caa853a55a618718e6f1c32')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('519f7e1b7caa853a55a618718e6f1c32')), 'alert-border');
    }
    statusComment = false;
  }
  if (statusFirstName != false && statusLastName != false && statusEmail != false && statusPhone != false && statusEmailValidation != false && statusPhoneValidation != false && statusSubject != false && statusComment != false) {
    ___arguments.context.pageData['chengedLabel'] = 'Sending...';
    await Backendless.Messaging.sendEmail('Message from contact-form', new Backendless.Bodyparts({ htmlmessage: (['First name: ',firstName,'<br>','Last name: ',lastName,'<br>','Email: ',email,'<br>','Phone: ','<a href="',phone,'">',phone,'</a>','<br>','Subject: ',subject,'<br>','Comment or message: ',message].join('')) }), [(getObjectProperty(___arguments.context.pageData, 'email'))], undefined);
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcc16e62d749b1a902a93ef75d6d95', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1731f88481a31bc6b32bb726e191ba1e'))['margin-top'] = '50%';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1731f88481a31bc6b32bb726e191ba1e'))['margin-bottom'] = '50%';
    ___arguments.context.pageData['alertSuccess'] = 'Thanks for contacting us! We will be in touch with you shortly.';
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'chengedLabel'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/contact/components/fd06bcca9f19ca06a94952ae76f442a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fd06bcca9f19ca06a94952ae76f442a5'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/f4a42b86cc59a1844c7ef2b97602d474/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f4a42b86cc59a1844c7ef2b97602d474'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/5d07b41b51934e5d1ae8dcbff72a21f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5d07b41b51934e5d1ae8dcbff72a21f4'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e3672305f3feaf45da95945d48d7dfda'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/75ab2e99aac58358bcc170a7326c158d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('75ab2e99aac58358bcc170a7326c158d'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('742626d8325168e5c869103fe75a7d7e'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/676edd95dd327a0788fd780533dabe96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('676edd95dd327a0788fd780533dabe96'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('85b4da7593f19d25ac788697ba7686ea'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/ff0ad7d368a632e44fdf6bfad74a482f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('676edd95dd327a0788fd780533dabe96'))['el']) {
    ;await ( async function (component){ component.focus() })((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('519f7e1b7caa853a55a618718e6f1c32'))['el']));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/b6b77a5b3457a6ae2cc24922053174d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageFirstName'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9')).pop();
  if (!(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['firstName'])) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageFirstName'] = (___arguments.context.pageData['alertMessage']);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('b6b77a5b3457a6ae2cc24922053174d9')), 'alert-border');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/e3672305f3feaf45da95945d48d7dfda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageLastName'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e3672305f3feaf45da95945d48d7dfda')).pop();
  if (!(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['lastName'])) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageLastName'] = (___arguments.context.pageData['alertMessage']);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e3672305f3feaf45da95945d48d7dfda')), 'border-red');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/742626d8325168e5c869103fe75a7d7e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageEmail'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('742626d8325168e5c869103fe75a7d7e')).pop();
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95'), 'email'))) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageEmail'] = (getObjectProperty(___arguments.context.pageData, 'alertMessage'));
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('742626d8325168e5c869103fe75a7d7e')), 'alert-border');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/85b4da7593f19d25ac788697ba7686ea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageSubject'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('85b4da7593f19d25ac788697ba7686ea')).pop();
  if (!(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['subject'])) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageSubject'] = (___arguments.context.pageData['alertMessage']);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('85b4da7593f19d25ac788697ba7686ea')), 'border-red');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/519f7e1b7caa853a55a618718e6f1c32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageComment'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('519f7e1b7caa853a55a618718e6f1c32')).pop();
  if (!(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['message'])) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessageComment'] = (___arguments.context.pageData['alertMessage']);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('519f7e1b7caa853a55a618718e6f1c32')), 'border-red');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/be7d4d44e5ffddaf999f8563f50341c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/21cb605f68eefb7f5ed33a73b3e88cd5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/8107232616af575bda6dc094a2e35a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), true, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['phoneNumber'] = (String('+01 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['phoneNumber'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/contact/components/045e175894a3e7f942cb2d0da2dbd6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['chengedLabel'] = 'Send message';

___arguments.context.pageData['chengedLabel'] = 'Send mesage';

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/contact/components/35bb5ab32c35f81cef925a6159544c12/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessagePhone'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')).pop();
  if (!(___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['phoneNumber'])) {
    ___arguments.context.getComponentDataStoreByUid('39dcc16e62d749b1a902a93ef75d6d95')['alertMessagePhone'] = (___arguments.context.pageData['alertMessage']);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('35bb5ab32c35f81cef925a6159544c12')), 'alert-border');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/contact/components/c54445ffc01c2768d6dfa53c44bb5db6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('be0bf98b2e4f1343e6f89d02d43a61a8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/2911e9a9915d87eb86ee00d193573b75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('be0bf98b2e4f1343e6f89d02d43a61a8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/contact/components/a193d1822483ba67ab66927b2f4fe47a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/2705e15dacac71bd9b380c8cac042f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).indexOf('fa-bars') + 1;
  if ((((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == 'hidden' || (((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'] = 'visible';
  } else {
    delete ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'];
  }
  if (list == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-bars');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-times');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var contacts, aboutMeDataTable, serviceDataTable, featuredInTable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ff059c4ed84655d481caa91c41936cf9'))['display'] = 'block';
  contacts = (await Backendless.Data.of('ContactInfo').findFirst());
  if (contacts && (getObjectProperty(contacts, 'sociallinks')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd89a514615b8f9515bc4bf2bd52aef8'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd89a514615b8f9515bc4bf2bd52aef8', (getObjectProperty(contacts, 'sociallinks')));
  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ff059c4ed84655d481caa91c41936cf9'))['display'] = 'none';
  featuredInTable = (await Backendless.Data.of('FeaturedIn').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (featuredInTable && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f1553b4bb5a0612c71604c53bdbeed5'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f1553b4bb5a0612c71604c53bdbeed5', featuredInTable);
  }
  ___arguments.context.pageData['topicsData'] = (await Backendless.Data.of('Topic').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  serviceDataTable = (await Backendless.Data.of('Service').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  ___arguments.context.pageData['serviceData'] = serviceDataTable;
  aboutMeDataTable = (await Backendless.Data.of('AboutMe').findFirst());
  ___arguments.context.pageData['intro'] = (getObjectProperty(aboutMeDataTable, 'intro'));
  ___arguments.context.pageData['shortbio'] = (getObjectProperty(aboutMeDataTable, 'shortbio'));
  ___arguments.context.pageData['quote'] = (getObjectProperty(aboutMeDataTable, 'quote'));
  ___arguments.context.pageData['picture1'] = ((getObjectProperty(aboutMeDataTable, 'pictures'))[0]);
  ___arguments.context.pageData['picture2'] = ((getObjectProperty(aboutMeDataTable, 'pictures'))[1]);
  ___arguments.context.pageData['testimonialsData'] = (await Backendless.Data.of('Testimonial').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  ___arguments.context.pageData['phone'] = (getObjectProperty(contacts, 'phone'));
  ___arguments.context.pageData['address'] = (getObjectProperty(contacts, 'address'));
  ___arguments.context.pageData['email'] = (getObjectProperty(contacts, 'email'));
  ___arguments.context.pageData['map'] = (getObjectProperty(contacts, 'map'));
  if (contacts && (getObjectProperty(contacts, 'sociallinks')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c437ff5d692611fcb95c24051539948f'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c437ff5d692611fcb95c24051539948f', (getObjectProperty(contacts, 'sociallinks')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/home/components/53ab341bac3b970b637f029bc3045591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var logoLink;


  logoLink = (___arguments.context.getComponentDataStoreByUid('99a4a288b34992b378cfc82cce7bc7bd')['link']);
  if (logoLink) {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(logoLink, true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('99a4a288b34992b378cfc82cce7bc7bd')['link']) != null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('99a4a288b34992b378cfc82cce7bc7bd'))['cursor'] = 'pointer';
  }

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home/components/52ccbc6f3789761a4dce48d9c357f405/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['description'] = (___arguments.context.dataModel['description']);
  ___arguments.context.appData['title'] = (___arguments.context.dataModel['title']);
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b38427f841eaaed825698e27dd6dae48'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home/components/f2544014468f0fed9b8da2fb81ebb194/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f2544014468f0fed9b8da2fb81ebb194'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['intro']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/58031633dbe9ab327f4c37093142c4d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('58031633dbe9ab327f4c37093142c4d2'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['quote']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/e984e4aa2e37874d708856168dd82283/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e984e4aa2e37874d708856168dd82283'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['phoneText']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/0e49a4ea4b9f3091e2fa7f712ff3d13c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['title'] = (___arguments.context.dataModel['title']);
  ___arguments.context.appData['description'] = (___arguments.context.dataModel['description']);
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/2a05c005a5a9bb6b89354307a948eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ['fab ', String('fa-') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d'), 'name'))]

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/5ddf06798a8cdbedae294e0d8065ab15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ['fab ', String('fa-') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322'), 'name'))]

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/b5a874a995e7c43b2865e74b84e766ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/71681102fa9e5aad1bf2670bb9af564e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['footerPhone'] = (String('+1 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['footerPhone'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/bef8769418d88f1cc059638e42c2e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel: ') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef8769418d88f1cc059638e42c2e3ea'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['phoneText'] = (['If You Have Any Questions, ','Feel Free to Call ',(___arguments.context.pageData['phone'])].join(''));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/home/components/3e3600f6b5065862c8d66da40684cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/a4694ba849b83db3d895a43bf626646a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/18f2ffbc54033412354c341522842954/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('about', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/f307ad752263f65472397b5ff2c84322/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f307ad752263f65472397b5ff2c84322'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/home/components/4c96e02b0b5eed9fd1929ae59944387d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c96e02b0b5eed9fd1929ae59944387d'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/home/components/2911e9a9915d87eb86ee00d193573b75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/c54445ffc01c2768d6dfa53c44bb5db6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/f3b4916f225b496f58ccbf3749965c0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/206c9c7ca97bfba1822bba417924b9f4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ff059c4ed84655d481caa91c41936cf9'))['display'] = 'block';

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/services/components/2705e15dacac71bd9b380c8cac042f1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).indexOf('fa-bars') + 1;
  if ((((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == 'hidden' || (((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'] = 'visible';
  } else {
    delete ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2c9719ad8095a32c2c1c9a160f697fb9'))['visibility'];
  }
  if (list == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-bars');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')).splice((list - 1), 1);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2705e15dacac71bd9b380c8cac042f1b')), 'fa-times');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var serviceDataTable, contacts, testimonialDataTable, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['topicsData'] = (await Backendless.Data.of('Topic').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  serviceDataTable = (await Backendless.Data.of('Service').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(100)));
  testimonialDataTable = (await Backendless.Data.of('Testimonial').find(Backendless.DataQueryBuilder.create().setPageSize(4)));
  ___arguments.context.pageData['serviceData'] = serviceDataTable;
  ___arguments.context.pageData['serviceDataText'] = serviceDataTable;
  for (var j_index in serviceDataTable) {
    j = serviceDataTable[j_index];
    if ((getObjectProperty(j, 'title')) == (getObjectProperty(___arguments.context.pageData, 'title'))) {
      ___arguments.context.pageData['description'] = (getObjectProperty(j, 'description'));
    }
  }
  if (serviceDataTable != '' || serviceDataTable != null) {
    ___arguments.context.pageData['description'] = (getObjectProperty(___arguments.context.pageData, 'description'));
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'description'))) {
    ___arguments.context.pageData['description'] = '';
  }
  ___arguments.context.pageData['testimonialsData'] = testimonialDataTable;
  ___arguments.context.pageData['picture'] = (getObjectProperty((testimonialDataTable[0]), 'picture'));
  ___arguments.context.pageData['quote'] = (getObjectProperty((testimonialDataTable[0]), 'quote'));
  ___arguments.context.pageData['name'] = (getObjectProperty((testimonialDataTable[0]), 'name'));
  contacts = (await Backendless.Data.of('ContactInfo').findFirst());
  ___arguments.context.pageData['phone'] = (getObjectProperty(contacts, 'phone'));
  ___arguments.context.pageData['address'] = (getObjectProperty(contacts, 'address'));
  ___arguments.context.pageData['email'] = (getObjectProperty(contacts, 'email'));
  ___arguments.context.pageData['map'] = (getObjectProperty(contacts, 'map'));
  if (contacts && (getObjectProperty(contacts, 'sociallinks')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd89a514615b8f9515bc4bf2bd52aef8')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c437ff5d692611fcb95c24051539948f'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c437ff5d692611fcb95c24051539948f', (getObjectProperty(contacts, 'sociallinks')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd89a514615b8f9515bc4bf2bd52aef8', (getObjectProperty(contacts, 'sociallinks')));
  }
  if (serviceDataTable && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f1553b4bb5a0612c71604c53bdbeed5'))) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f1553b4bb5a0612c71604c53bdbeed5', serviceDataTable);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/services/components/e984e4aa2e37874d708856168dd82283/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e984e4aa2e37874d708856168dd82283'))['el'])['children'])[0])['textContent'] = (___arguments.context.pageData['phoneText']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/services/components/0e49a4ea4b9f3091e2fa7f712ff3d13c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('services', ({ 'title': (___arguments.context.dataModel['title']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/2a05c005a5a9bb6b89354307a948eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('4c96e02b0b5eed9fd1929ae59944387d')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2a05c005a5a9bb6b89354307a948eb68'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/services/components/5ddf06798a8cdbedae294e0d8065ab15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['url']), true, null);
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'facebook') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-facebook'] = 'fab fa-facebook';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'twitter') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-twitter'] = 'fab fa-twitter';
  } else if ((___arguments.context.getComponentDataStoreByUid('f307ad752263f65472397b5ff2c84322')['name']) == 'instagram') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5ddf06798a8cdbedae294e0d8065ab15'))['fab fa-instagram'] = 'fab fa-instagram';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/services/components/b5a874a995e7c43b2865e74b84e766ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.pageData['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/71681102fa9e5aad1bf2670bb9af564e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel:') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.pageData['footerPhone'] = (String('+1 - ') + String(___arguments.context.pageData['phone']));

  return (___arguments.context.pageData['footerPhone'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/services/components/bef8769418d88f1cc059638e42c2e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('tel: ') + String(___arguments.context.pageData['phone'])), false, null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef8769418d88f1cc059638e42c2e3ea'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['phoneText'] = (['If You Have Any Questions, ','Feel Free to Call ',(___arguments.context.pageData['phone'])].join(''));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/services/components/3e3600f6b5065862c8d66da40684cc94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((___arguments.context.pageData['map']), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/a50cedbcdbe4e187c28a26fd308e1187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a50cedbcdbe4e187c28a26fd308e1187'))['cursor'] = 'pointer';

  },  
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/services/components/8552d54d0e67c8cc246da51f833f5a48/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var description;


  description = (___arguments.context.pageData['description']);
  if (!description) {
    return 'Diam lorem nulla suspendisse id ullamcorper lobortis id sit nisl purus tellus curabitur leo volutpat vitae quisque eros, gravida magna diam id elit facilisi gravida at non consectetur nulla leo congue in netus ut et habitant massa id libero turpis.';
  }

  return description

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/services/components/ca834a2141e1b4eec545182c5a4b26fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var title;


  title = (___arguments.context.pageData['title']);
  if (title != null) {
    return title;
  }

  return 'We All Need Help to Realize What We Want Most.'

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/services/components/30758b5fc8e362b360263633ff4b56ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      (((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('30758b5fc8e362b360263633ff4b56ba'))['el'])['children'])[0])['textContent'] = (___arguments.context.getComponentDataStoreByUid('99a4a288b34992b378cfc82cce7bc7bd')['title']);
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30758b5fc8e362b360263633ff4b56ba'))['services-block__title'] = 'services-block__title';

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/services/components/8b3b8bc20dcbf8e509cd3bb6c9f15a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('206c9c7ca97bfba1822bba417924b9f4')));
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/8b09665166f6970213e39a6670e43db6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b09665166f6970213e39a6670e43db6')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b09665166f6970213e39a6670e43db6', false);
    await new Promise(r => setTimeout(r, 1500 || 0));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b09665166f6970213e39a6670e43db6')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b09665166f6970213e39a6670e43db6', true);
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/services/components/f307ad752263f65472397b5ff2c84322/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f307ad752263f65472397b5ff2c84322'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/services/components/4c96e02b0b5eed9fd1929ae59944387d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if ((___arguments.context.dataModel['visibleOnNav']) == false) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c96e02b0b5eed9fd1929ae59944387d'))['display'] = 'none';
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/services/components/2911e9a9915d87eb86ee00d193573b75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/services/components/c54445ffc01c2768d6dfa53c44bb5db6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('contact', ({ 'scroll_to': 'form' }));

  },  
  /* handler:onClick */
  /* content */
}))

